export const NOTE_MAX_LENGTH = 2000;

/** Copy follows the mobile reporter, so a report reads the same either side. */
export const DEV_REPORT = {
  launch: "Report issue",
  capturing: "Capturing…",
  title: "Report issue",
  subtitle:
    "Your screenshot, the page you are on and this build are attached automatically.",
  noteLabel: "What went wrong?",
  notePlaceholder: "Describe what you expected to see",
  submit: "Submit report",
  submitting: "Sending…",
  cancel: "Cancel",
  close: "Close",
  screenshotAlt: "Screenshot attached to this report",
  captureFailed: "Could not capture the page. Close this and try again.",
  submitFailed: "Could not send the report. Check the connection and try again.",
  sentTitle: "Report sent",
  sentBody: "It is now in Nucleus under Developers.",
} as const;
